import { Card, CardContent, Typography, Box } from "@mui/material";

export const OrderNotes = ({ note }: { note: string }) => (
  <Card sx={{ p: 2, mb: 3, bgcolor: "background.paper", borderRadius: 2, boxShadow: 2 }}>
    <CardContent>
      <Typography variant="h6" gutterBottom>
        Order Notes
      </Typography>
      <Box sx={{ p: 2, bgcolor: "background.paper", borderRadius: 1, border: "1px solid", borderColor: "grey.300" }}>
        <Typography variant="body1" sx={{ fontStyle: "italic", color: "text.secondary" }}>
          {note}
        </Typography>
      </Box>
    </CardContent>
  </Card>
);